<div class="gpd-full-page">
  <div class="gpd-inner-page height-limitverview-container">
    <!--
      Above the grid rather than inside dxo-toolbar: the DevExtreme grid toolbar is a fixed
      height single row, so a second row of filters overflows it and the grid paints over it.
      This is also where project-pipline-filters and project-list-filters put their bars.
    -->
    <div class="cost-toolbar">
      <dx-text-box
        [(value)]="searchTerm"
        mode="search"
        valueChangeEvent="keyup"
        class="custom-search-panel"
        (onValueChanged)="dataGrid.instance.searchByText($event.value)"
        i18n-placeholder="@@costsSearch"
        placeholder="Search costs..."
      ></dx-text-box>

      <!-- Same bar as the pipeline and the project list: glyph, scope pill, divider, filters, reset. -->
      <div class="filter-section">
        <div class="filter-icon-wrapper">
          <app-svg-icon icon="filter" [size]="20" color="var(--color-primary)"></app-svg-icon>
        </div>
        <gpd-filter
          i18n-text="@@meineAnsicht"
          text="Meine Ansicht"
          [value]="myCostsFilter"
          (valueChange)="setMyCostsFilter($event)"
          [options]="myCostsItems"
          [multiple]="true"
          [nullable]="true"
          [disableAll]="true"
          [disableSearch]="true"
          [activeWhenNotEmpty]="true"
        ></gpd-filter>
        <div class="filter-divider"></div>
        <gpd-filter
          i18n-text="@@commissioning"
          text="Commissioning"
          [value]="beauftragtFilter"
          (valueChange)="setBeauftragtFilter($event)"
          [options]="beauftragtItems"
          [multiple]="true"
          [inactiveWhenEmpty]="true"
          [disableSearch]="true"
        ></gpd-filter>
        <gpd-filter
          i18n-text="@@company"
          text="Company"
          [value]="selectedDebitors"
          (valueChange)="setDebitorFilter($event)"
          [options]="debitorOptions"
          [multiple]="true"
          [inactiveWhenEmpty]="true"
        ></gpd-filter>
        <!--
          A display mode, not a filter: every amount on screen is either gross or net, so it is
          always "on" and there is nothing to signal. neverActive keeps it neutral, and it stays
          out of hasActiveFilters so it neither raises nor is cleared by "Filter zurücksetzen".
        -->
        <gpd-filter
          i18n-text="@@amounts"
          text="Amounts"
          [value]="amountBasis"
          (valueChange)="setAmountBasis($event)"
          [options]="amountBasisItems"
          [multiple]="false"
          [nullable]="false"
          [disableAll]="true"
          [disableSearch]="true"
          [neverActive]="true"
        ></gpd-filter>
        <app-gpd-button
          *ngIf="hasActiveFilters"
          type="text"
          class="reset-filters"
          i18n-text="@@resetFilters"
          text="Reset Filters"
          (onClick)="resetFilters()"></app-gpd-button>

        <!-- Pushed to the far end of the row; not a filter, so it sits past the reset link. -->
        <app-gpd-button class="filter-row-export" type="tertiary" i18n-text="@@export"
          text="Export" icon="download" (onClick)="onExportClick()"></app-gpd-button>
        <dx-context-menu [(visible)]="exportMenuVisible" target=".filter-row-export" [items]="exportMenuItems"
          [position]="{ my: 'right top', at: 'right bottom' }" cssClass="gpd-context-menu"
          (onItemClick)="onExportMenuItemClick($event)"></dx-context-menu>
      </div>
    </div>

    <dx-data-grid class="gpd-datagrid table-container project-cost-overview-grid" #dataGrid [dataSource]="projectList"
      [showRowLines]="true" [paging]="false" [showBorders]="true" [wordWrapEnabled]="false" [height]="'100%'"
      [sorting]="false" [grouping]="{autoExpandAll: false}" (onContextMenuPreparing)="showContextMenu($event)"
      (onCellPrepared)="onCellPrepared($event)" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
      [columnAutoWidth]="false" [showBorders]="true" [width]="'100%'" [rowAlternationEnabled]="true"
      [hoverStateEnabled]="true" [showColumnLines]="true">
      <dxo-selection mode="single"></dxo-selection>
      <!--
        No dxo-export: it only ever added DevExtreme's own export glyph to the grid toolbar,
        with no onExporting handler behind it (the W1024 build warning). The custom toolbar
        used to hide it; now that the toolbar lives outside the grid, it would show up beside
        the real "Exportieren" button. exportAsExcel calls exportDataGrid directly and is
        unaffected by this option.
      -->
      <!-- <dxo-scrolling mode="standard" rowRenderingMode="virtual" columnRenderingMode="virtual"></dxo-scrolling> -->
      <dxo-header-filter [visible]="false"></dxo-header-filter>

      <dxi-column dataField="summaryId" [groupIndex]="0" groupCellTemplate="summaryGroupCellTemplate"
        [autoExpandGroup]="true">
        <div *dxTemplate="let item of 'summaryGroupCellTemplate'">
          <span i18n="@@total" style="margin-left: 30px;">
            Total:
          </span>
        </div>
      </dxi-column>

      <dxi-column [allowResizing]="false" dataField="key" [groupIndex]="1" groupCellTemplate="groupCellTemplate"
        [fixed]="true" [visible]="false">
        <div *dxTemplate="let item of 'groupCellTemplate'">
          <div> {{ item.data.key }} </div>
        </div>
      </dxi-column>

      <dxi-column [allowResizing]="false" dataField="category" i18n-caption="@@projectDetails" caption="Project Detail"
        cssClass="cell-highlighted" [width]="250" [fixed]="true" [allowSearch]="true">
     
      </dxi-column>

        <dxi-column dataField="details" i18n-caption="@@responsibleUser" caption="Responsible User" [fixed]="true" [width]="200" [allowSearch]="true"></dxi-column>

        <dxi-column column="fake" dataType="string" i18n-caption  [fixed]="true"
          cssClass="cell-highlighted" [width]="200" [allowSearch]="true"></dxi-column>

        <dxi-column name="fake" [allowSearch]="false" [showInColumnChooser]="false" [fixed]="true" fixedPosition="left"
          [width]="0.01"></dxi-column>

      <ng-container *ngFor="let date of dates; let i = index">
        <dxi-column [dataField]="date" [allowSearch]="false" [caption]="formatHeaderDate(date)"
          headerCellTemplate="headerCellTemplate" [alignment]="'left'" [width]="200" [format]="'#,##0.00 €'"
          [cssClass]="isCurrentWeek(date) ? 'current-week-column' : ''">
          <div *dxTemplate="let item of 'headerCellTemplate'">
            <div *ngIf="item.column.index > 4" class="header-container">
              <div class="header-subtext" style="font-weight: normal;"> {{ formatHeaderDate(item.column.dataField) }}
              </div>
            </div>
          </div>
        </dxi-column>
      </ng-container>

      <dxo-summary [skipEmptyValues]="true">
        <dxi-group-item column="fake" [alignByColumn]="true" summaryType="count"> </dxi-group-item>
        <ng-container *ngFor="let date of dates; let i = index">
          <dxi-group-item [column]="date" [alignByColumn]="true" displayFormat="{0}" summaryType="sum"
            [skipEmptyValues]="true" [valueFormat]="formatEuro">
          </dxi-group-item>
        </ng-container>
      </dxo-summary>
    </dx-data-grid>

    <!-- Details Popup Box-->
    <div *ngIf="popupVisible">
      <dx-popup [title]="title" [showTitle]="true" [width]="1100" [maxWidth]="'90vw'"
        [height]="'auto'" [minHeight]="'55vh'" [maxHeight]="'80vh'" [dragEnabled]="true"
        [position]="centerOnScreen" [wrapperAttr]="{ class: 'project-cost-details-popup' }"
        [hideOnOutsideClick]="true" [showCloseButton]="true" container=".dx-viewport" [(visible)]="popupVisible"
        [resizeEnabled]="true">
        <div *ngIf="popupVisible">
          <dx-data-grid [dataSource]="allDetailsPopup" style="font-weight: 200; font-size: larger" width="auto"
            [wordWrapEnabled]="true" [allowColumnResizing]="true" [columnResizingMode]="'widget'"
            [columnAutoWidth]="false" [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }"
            [width]="'100%'" class="gt-data-grid-style" [rowAlternationEnabled]="true" [hoverStateEnabled]="true">
            <dxi-column [allowResizing]="true" dataField="name" i18n-caption="@@costType"
              caption="Cost Type"></dxi-column>
            <dxi-column [allowResizing]="true" dataField="moreDetails" i18n-caption caption="More Details"
              width="250"></dxi-column>
            <dxi-column [allowResizing]="true" dataField="amount" i18n-caption caption="Amount" format="#,##0.00 €"
              alignment="left"></dxi-column>
            <dxi-column [allowResizing]="true" dataField="date" i18n-caption="@@plannedDate"
              [customizeText]="formatDate" caption="Planned Date"></dxi-column>
            <dxi-column [allowResizing]="true" dataField="debitor" dataType="string"
              [customizeText]="debitorCellText" i18n-caption caption="Debitor"></dxi-column>
            <dxi-column [allowResizing]="true" dataField="beauftragt" dataType="boolean"
              i18n-caption="@@commissioned" caption="Commissioned"></dxi-column>
          </dx-data-grid>
        </div>
      </dx-popup>
    </div>
  </div>
</div>

<dx-popup [title]="popupTitle" [showTitle]="true" [width]="1500" [maxWidth]="'90vw'" [height]="'auto'"
  [maxHeight]="'80vh'" [dragEnabled]="true"
  [hideOnOutsideClick]="true" [showCloseButton]="true" container=".dx-viewport" [(visible)]="showRelatedCosts"
  [resizeEnabled]="true" (onHidden)="onPopupHidden()" (onShowing)="onPopupShow()">
  <div *ngIf="hasMilestoneLinkedCosts" class="milestone-hinweis" role="alert">
    <strong i18n="@@noteLabel">Note:</strong>
    <span i18n="@@milestoneShiftWarning">Some of these costs are linked to a milestone. You can still shift them, but doing so will break the milestone link.</span>
  </div>
  <div *ngIf="showGrid">
    <dx-data-grid #dxgrid [dataSource]="linkedCosts" keyExpr="costId" [selectedRowKeys]="selectedCosts"
      style="font-weight: 200; font-size: larger" width="auto"
      [wordWrapEnabled]="true" [allowColumnResizing]="true" [columnResizingMode]="'widget'" [columnAutoWidth]="false"
      [showBorders]="true" [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'"
      class="gt-data-grid-style" [rowAlternationEnabled]="true" [hoverStateEnabled]="true"
      (onSelectionChanged)="onSelectionChanged($event)">
      <dxi-column [allowResizing]="true" dataField="name" i18n-caption="@@costType" caption="Cost Type"></dxi-column>
      <dxi-column [allowResizing]="true" dataField="serviceProvider" i18n-caption caption="Service Provider"></dxi-column>
      <dxi-column [allowResizing]="true" dataField="moreDetails" i18n-caption caption="More Details"
        width="250"></dxi-column>
      <dxi-column [allowResizing]="true" dataField="amount" i18n-caption caption="Amount" format="#,##0.00 €"
        alignment="left"></dxi-column>
      <dxi-column [allowResizing]="true" dataField="date" i18n-caption="@@plannedDate" [customizeText]="formatDate"
        caption="Planned Date"></dxi-column>
      <dxi-column [allowResizing]="true" dataField="milestoneLabel" i18n-caption="@@milestoneLink"
        caption="Milestone link"></dxi-column>

      <dxo-selection mode="multiple"></dxo-selection>
    </dx-data-grid>
  </div>

  <div class="container-btn">
    <app-gpd-button type="primary" i18n-text="@@moveCost" text="MOVE COST" [disabled]="!selectedCosts?.length"
      (onClick)="shiftBy()"></app-gpd-button>
  </div>
</dx-popup>